// The Latin-1 + Windows-1252 named references plus common typographic ones.
// Entity names are case-sensitive (Auml ≠ auml); AMP/COPY/… are the WHATWG
// uppercase legacy aliases.
export const NAMED_HTML_ENTITIES: Record<string, string> = {
  AElig: "Æ",
  AMP: "&",
  Aacute: "Á",
  Acirc: "Â",
  Agrave: "À",
  Aring: "Å",
  Atilde: "Ã",
  Auml: "Ä",
  COPY: "©",
  Ccedil: "Ç",
  Dagger: "‡",
  ETH: "Ð",
  Eacute: "É",
  Ecirc: "Ê",
  Egrave: "È",
  Euml: "Ë",
  GT: ">",
  Iacute: "Í",
  Icirc: "Î",
  Igrave: "Ì",
  Iuml: "Ï",
  LT: "<",
  Ntilde: "Ñ",
  OElig: "Œ",
  Oacute: "Ó",
  Ocirc: "Ô",
  Ograve: "Ò",
  Oslash: "Ø",
  Otilde: "Õ",
  Ouml: "Ö",
  QUOT: '"',
  REG: "®",
  Scaron: "Š",
  THORN: "Þ",
  TRADE: "™",
  Uacute: "Ú",
  Ucirc: "Û",
  Ugrave: "Ù",
  Uuml: "Ü",
  Yacute: "Ý",
  Yuml: "Ÿ",
  aacute: "á",
  acirc: "â",
  acute: "´",
  aelig: "æ",
  agrave: "à",
  amp: "&",
  apos: "'",
  aring: "å",
  atilde: "ã",
  auml: "ä",
  bdquo: "„",
  brvbar: "¦",
  bull: "•",
  ccedil: "ç",
  cedil: "¸",
  cent: "¢",
  circ: "ˆ",
  copy: "©",
  curren: "¤",
  dagger: "†",
  deg: "°",
  divide: "÷",
  eacute: "é",
  ecirc: "ê",
  egrave: "è",
  emsp: "\u2003",
  ensp: "\u2002",
  eth: "ð",
  euml: "ë",
  euro: "€",
  fnof: "ƒ",
  frac12: "½",
  frac14: "¼",
  frac34: "¾",
  gt: ">",
  hellip: "…",
  iacute: "í",
  icirc: "î",
  iexcl: "¡",
  igrave: "ì",
  iquest: "¿",
  iuml: "ï",
  laquo: "«",
  ldquo: "“",
  lsaquo: "‹",
  lsquo: "‘",
  lt: "<",
  macr: "¯",
  mdash: "—",
  micro: "µ",
  middot: "·",
  nbsp: " ",
  ndash: "–",
  not: "¬",
  ntilde: "ñ",
  oacute: "ó",
  ocirc: "ô",
  oelig: "œ",
  ograve: "ò",
  ordf: "ª",
  ordm: "º",
  oslash: "ø",
  otilde: "õ",
  ouml: "ö",
  para: "¶",
  permil: "‰",
  plusmn: "±",
  pound: "£",
  quot: '"',
  raquo: "»",
  rdquo: "”",
  reg: "®",
  rsaquo: "›",
  rsquo: "’",
  sbquo: "‚",
  scaron: "š",
  sect: "§",
  shy: "\u00ad",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  szlig: "ß",
  thinsp: "\u2009",
  thorn: "þ",
  tilde: "˜",
  times: "×",
  trade: "™",
  uacute: "ú",
  ucirc: "û",
  ugrave: "ù",
  uml: "¨",
  uuml: "ü",
  yacute: "ý",
  yen: "¥",
  yuml: "ÿ",
  zwj: "\u200d",
  zwnj: "\u200c",
};

// Browsers decode C1-range (0x80–0x9F) numeric references as Windows-1252 —
// e.g. `&#146;` (Word smart quote) is ’, not an invisible control character.
export const CP1252_CODE_POINTS: Record<number, string> = {
  0x80: "€",
  0x82: "‚",
  0x83: "ƒ",
  0x84: "„",
  0x85: "…",
  0x86: "†",
  0x87: "‡",
  0x88: "ˆ",
  0x89: "‰",
  0x8a: "Š",
  0x8b: "‹",
  0x8c: "Œ",
  0x8e: "Ž",
  0x91: "‘",
  0x92: "’",
  0x93: "“",
  0x94: "”",
  0x95: "•",
  0x96: "–",
  0x97: "—",
  0x98: "˜",
  0x99: "™",
  0x9a: "š",
  0x9b: "›",
  0x9c: "œ",
  0x9e: "ž",
  0x9f: "Ÿ",
};
